import type { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  size?: 'sm' | 'md';
};

const EmptyState = ({ icon, title, description, action, size = 'md' }: EmptyStateProps) => {
  const isSm = size === 'sm';
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        padding: isSm ? '24px 16px' : '48px 16px',
        textAlign: 'center',
        color: 'var(--shell-text-secondary)',
      }}
    >
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: isSm ? 36 : 48,
          height: isSm ? 36 : 48,
          borderRadius: '50%',
          background: 'var(--shell-bg-subtle)',
          color: 'var(--shell-text-tertiary)',
        }}
      >
        {icon ?? <Inbox size={isSm ? 18 : 22} strokeWidth={1.5} />}
      </div>
      <div
        style={{
          fontSize: isSm ? 13 : 14,
          fontWeight: 500,
          color: 'var(--shell-text-primary)',
        }}
      >
        {title}
      </div>
      {description && (
        <div
          style={{
            fontSize: 12,
            color: 'var(--shell-text-tertiary)',
            maxWidth: 360,
            lineHeight: 1.5,
          }}
        >
          {description}
        </div>
      )}
      {action && <div style={{ marginTop: 6 }}>{action}</div>}
    </div>
  );
};

export default EmptyState;
